/**
 * File: useAppSidebarController.ts
 * Path: apps/admin/src/modules/layout/hooks/useAppSidebarController.ts
 * Description: What the sidebar shows: the signed-in user, the menu items their role may see, whether the
 * sidebar is open, and the sign-out and collapse actions.
 */

import { useAuthMutations } from "@/modules/auth/hooks/useAuthMutations";
import { useMenuItems } from "@/modules/layout/hooks/useMenuItemsQueries";
import { useAuth } from "@/modules/auth/components/AuthProvider";
import { useUIStore } from "@/modules/app/hooks/useUiState";

export const useAppSidebarController = () => {
  const { user } = useAuth();
  const { logout, isPending } = useAuthMutations();
  const { isSidebarCollapsed, toggleSidebar } = useUIStore();

  const isOpen = !isSidebarCollapsed;
  const userInitial = user?.email ? user.email.charAt(0).toUpperCase() : "U";

  const filteredItems = useMenuItems();

  return {
    email: user?.email,
    isOpen,
    userInitial,
    filteredItems,
    isPending,
    toggleSidebar,
    logout: () => logout(),
  };
};
